export const hireDevOpsData = {

    // HirePageBanner Content
    mainBanner: {
        shortHeading: "For Efficient Workflows and Robust Systems",
        mainHeading: "Build scalable, reliable <span>DevOps solutions</span> with engineers trusted by 50+ global brands.",
        content: "Need a proven DevOps partner? Our engineers help businesses automate deployments, increase scalability by up to 40%, and optimize cloud infrastructure to improve performance by 25%. Partner with us to implement CI/CD pipelines, reduce deployment times by 50%, and streamline cloud operations to enhance delivery efficiency.",
    },

    // HirePageExperties Content
    flutterExpertise: {
        btnText: "Hire DevOps Engineers For Any Service",
        shortHeading: "Our DevOps Engineering Services",
        heading: "Expert DevOps Engineers to Drive Your Business Forward",
        description: "DevOps Engineering Solutions for Scalable, High-Impact Infrastructure. Our top-tier DevOps engineers specialize in optimizing and building scalable, high-performance infrastructure. With years of experience delivering performance-driven solutions, our team empowers businesses to scale efficiently. Partner with us to access flexible, scalable DevOps teams that evolve alongside your project's needs.",
        servicesData: [
            {
                title: "CI/CD Pipeline Automation",
                description: "We design and implement robust Continuous Integration and Continuous Deployment pipelines using tools like Jenkins, GitHub Actions, and GitLab CI to ensure faster, error-free software delivery.",
                icon: "/images/hire-page-icons/flutter-icon-1.svg",
            },
            {
                title: "Infrastructure as Code (IaC)",
                description: "Our engineers automate infrastructure provisioning and management using Terraform, Ansible, and CloudFormation enabling consistent, version-controlled, and repeatable environments across all deployments.",
                icon: "/images/hire-page-icons/flutter-icon-2.svg",
            },
            {
                title: "Cloud Infrastructure Management",
                description: "From AWS and Azure to Google Cloud, we build and maintain secure, scalable cloud architectures that maximize uptime, reduce costs, and simplify operations.",
                icon: "/images/hire-page-icons/flutter-icon-3.svg",
            },
            {
                title: "Containerization & Orchestration",
                description: "We deploy and manage containerized environments using Docker and Kubernetes, ensuring consistent performance, simplified scaling, and streamlined application management across clusters.",
                icon: "/images/hire-page-icons/flutter-icon-4.svg",
            },
            {
                title: "Monitoring & Logging",
                description: "Our team sets up comprehensive observability systems with Prometheus, Grafana, and ELK stacks to track performance, detect anomalies early, and maintain system health proactively.",
                icon: "/images/hire-page-icons/flutter-icon-5.svg",
            },
            {
                title: "Security & Compliance Automation",
                description: "We integrate security checks into every stage of development with DevSecOps practices automating compliance, vulnerability scans, and access control for continuous protection.",
                icon: "/images/hire-page-icons/flutter-icon-6.svg",
            },
            {
                title: "Version Control & Workflow Optimization",
                description: "We implement Git-based workflows, branching strategies, and automation hooks to improve collaboration, reduce errors, and maintain high code quality across distributed teams.",
                icon: "/images/hire-page-icons/flutter-icon-7.svg",
            },
            {
                title: "Performance Optimization & Cost Efficiency",
                description: "We fine-tune infrastructure and workloads to improve system efficiency, minimize latency, and optimize cloud spending helping you scale smartly without overspending.",
                icon: "/images/hire-page-icons/flutter-icon-8.svg",
            },
        ]
    },

    ctaSection: {
        mainHeading: "Need Reliable DevOps Engineers?",
        description: "Get expert DevOps support to automate workflows, improve deployment speed, and keep your systems running smoothly.",
        btnText: "Hire DevOps Experts",
        btnLink: "/contact-us",
    },


    testimonialsData: [
        {
            name: "Michael Turner",
            enterprise: "Cloud Infrastructure & Automation",
            country: "Austin, US",
            profileImage: "/images/testimonials/michael.avif",
            logoImage: "/images/logo-2.png",
            countryFlagImage: "/images/testimonials/flags/usa-flag.png",
            designation: "CTO at BrightPath Logistics",
            feedback: "The DevOps team streamlined our CI/CD pipelines and automated key deployment processes across multiple environments. The result? Faster releases, fewer errors, and improved system reliability that transformed our entire delivery workflow",
            serviceTags: [{
                title: "Cloud Infrastructure & Automation",
                link: "#"
            }]
        },
        {
            name: "Emily Roberts",
            enterprise: "Healthcare Infrastructure",
            country: "San Francisco, US",
            countryFlagImage: "/images/testimonials/flags/usa-flag.png",
            designation: "Head of Engineering at HealthPlus",
            profileImage: "/images/testimonials/sophie.avif",
            logoImage: "/images/logo-2.png",
            feedback: "The engineers implemented a secure, containerized cloud setup with real-time monitoring and compliance automation. It reduced downtime by 40% and gave our tech teams complete visibility and control over operations.",
            serviceTags: [{
                title: "Healthcare Infrastructure",
                link: "#"
            }]
        },
    ],

    // DevelopmentPerformance Content (Why Choose Us)
    whyUsContent: {
        heading: " with Our DevOps Engineers?",
        greenHeading: "Why Work",
        content: "We provide highly skilled, top-tier DevOps engineers who deliver tailored solutions to drive efficiency, innovation, and growth. With our team, you get a group that combines expertise, agility, and scalability to tackle your toughest infrastructure and operational challenges.",
        stats: [
            {
                title: "Faster Time to Onboard",
                number: "66%", // faster onboarding
            },
            {
                title: "Faster Project Delivery",
                number: "33%", // faster delivery with streamlined solutions
            },
            {
                title: "Successful DevOps Transformations",
                number: "10+", // number of successful transformations
            },
            {
                title: "Full-Stack DevOps Engineers",
                number: "10+", // number of engineers
            },
        ],
        cta: {
            text: "Partner With us Today",
            link: "/contact-us",
        }
    },

    mlSolutionsData: [
        {
            title: "Access to Pre-Vetted DevOps Talent",
            description: "We provide access to a network of rigorously tested DevOps engineers, cloud architects, and automation specialists. Each professional is screened for hands-on experience with CI/CD, containerization, cloud platforms, and infrastructure automation, ensuring you onboard battle-tested talent.",
        },
        {
            title: "Rapid Onboarding & Seamless Integration",
            description: "Our engineers integrate with your team in as little as 48 hours. We align time zones, toolchains, and workflows, ensuring smooth collaboration and eliminating deployment delays from day one.",
        },
        {
            title: "End-to-End DevOps Implementation",
            description: "We streamline your entire software delivery lifecycle by implementing automated CI/CD pipelines, infrastructure as code, and monitoring solutions. This reduces manual workloads by up to 50% and accelerates deployment cycles by 60%.",
        },
        {
            title: "Scalable Infrastructure & Cloud Optimization",
            description: "We optimize your infrastructure to handle dynamic workloads, saving up to 40% in cloud costs by configuring cost-efficient environments on AWS, Azure, and GCP. Our engineers implement auto-scaling to ensure resources match business demands without overprovisioning.",
        },
        {
            title: "Robust Security & Compliance",
            description: "We ensure 100% compliance with ISO, SOC 2, and GDPR standards through DevSecOps practices. All projects begin under strict NDAs, and we maintain comprehensive security documentation throughout the DevOps lifecycle.",
        },
        {
            title: "Continuous Monitoring & Improvement",
            description: "We implement real-time monitoring and alerting systems that proactively identify issues before they impact users. Our continuous improvement approach ensures your DevOps systems remain efficient, reliable, and cost-effective.",
        },
    ],

    // HireCombinationSection Content
    techCombinations: {
        shortHeading: "Powerful Technology Combinations Our DevOps Engineers Use",
        heading: "Top DevOps Toolchains for Scalable, Reliable & Automated Delivery",
        description: "We bring together the best DevOps frameworks, automation tools, and cloud technologies to build efficient, secure, and scalable systems. Each combination is carefully selected to accelerate releases, improve reliability, and ensure cost-effective operations.",
        combinations: [
            {
                title: "Docker + Kubernetes + Helm",
                description: "A powerful trio for containerization and orchestration. Docker ensures consistency across environments, Kubernetes handles scaling and deployment, and Helm simplifies configuration management enabling seamless, zero-downtime deployments across clouds.",
                icons: [
                    { icon: "docker.svg", altText: "Docker container platform" },
                    { icon: "kubernetes.svg", altText: "Kubernetes container orchestration" },
                    { icon: "helm.svg", altText: "Helm package manager" },
                ],
            },
            {
                title: "Terraform + Ansible + AWS",
                description: "Automate infrastructure setup and configuration with Infrastructure as Code. Terraform provisions resources, Ansible manages configurations, and AWS delivers scalable, high-availability environments reducing human error and deployment time.",
                icons: [
                    { icon: "terraform.png", altText: "Terraform infrastructure as code" },
                    { icon: "ansible.png", altText: "Ansible configuration management" },
                    { icon: "aws.svg", altText: "Amazon Web Services" },
                ],
            },
            {
                title: "GitLab CI + Jenkins + GitHub Actions",
                description: "This CI/CD powerhouse automates code integration, testing, and deployment. Together, they create flexible, multi-platform pipelines that ensure continuous delivery, version control, and robust quality assurance.",
                icons: [
                    { icon: "gitlab.svg", altText: "GitLab CI" },
                    { icon: "jenkins.svg", altText: "Jenkins automation server" },
                    { icon: "github-actions.svg", altText: "GitHub Actions" },
                ],
            },
            {
                title: "Prometheus + Grafana + ELK Stack",
                description: "Monitor, analyze, and visualize everything in real-time. Prometheus collects performance metrics, Grafana displays actionable dashboards, and ELK (Elasticsearch, Logstash, Kibana) provides centralized logging for fast incident response.",
                icons: [
                    { icon: "prometheus.svg", altText: "Prometheus monitoring" },
                    { icon: "grafana.png", altText: "Grafana visualization" },
                    { icon: "elasticsearch.svg", altText: "ELK Stack" },
                ],
            },
            {
                title: "Azure DevOps + Docker + Terraform",
                description: "Ideal for enterprises running hybrid environments. Azure DevOps orchestrates workflows, Docker standardizes containers, and Terraform automates multi-cloud provisioning ensuring smooth integration and faster releases.",
                icons: [
                    { icon: "azure-devops.png", altText: "Azure DevOps" },
                    { icon: "docker.svg", altText: "Docker container platform" },
                    { icon: "terraform.png", altText: "Terraform infrastructure as code" },
                ],
            },
            {
                title: "Vault + SonarQube",
                description: "Integrate security and quality assurance seamlessly into the DevOps lifecycle. Vault safeguards secrets and access credentials, while SonarQube continuously analyzes code quality ensuring compliance and reliability across your stack.",
                icons: [
                    { icon: "vault.png", altText: "HashiCorp Vault" },
                    { icon: "sonarqube.svg", altText: "SonarQube code quality" },
                ],
            },
            {
                title: "CircleCI + AWS Lambda",
                description: "For teams embracing serverless architectures, CircleCI automates build and testing pipelines while AWS Lambda executes code on demand optimizing performance without maintaining servers.",
                icons: [
                    { icon: "circleci.svg", altText: "CircleCI" },
                    { icon: "aws-lambda.svg", altText: "AWS Lambda" },
                ],
            },
            {
                title: "Kubernetes + Istio + Prometheus",
                description: "A complete ecosystem for scalable, microservice-driven operations. Kubernetes manages containers, Istio handles service mesh traffic and policies, while Prometheus ensures observability and proactive performance monitoring.",
                icons: [
                    { icon: "kubernetes.svg", altText: "Kubernetes container orchestration" },
                    { icon: "istio.png", altText: "Istio service mesh" },
                    { icon: "prometheus.svg", altText: "Prometheus monitoring" },
                ],
            },
            {
                title: "GitHub Actions + Docker + AWS ECS",
                description: "Automate your full deployment pipeline from code to production. GitHub Actions triggers builds, Docker packages applications, and ECS manages container orchestration simplifying DevOps at scale.",
                icons: [
                    { icon: "github-actions.svg", altText: "GitHub Actions" },
                    { icon: "docker.svg", altText: "Docker container platform" },
                    { icon: "aws-ecs.png", altText: "AWS ECS" },
                ],
            },
            {
                title: "Terraform + Azure + CloudFormation",
                description: "For multi-cloud reliability, this combination automates infrastructure setup across AWS and Azure, ensuring cross-platform consistency, reproducibility, and security.",
                icons: [
                    { icon: "terraform.png", altText: "Terraform infrastructure as code" },
                    { icon: "azure.svg", altText: "Microsoft Azure" },
                    { icon: "cloudformation.png", altText: "AWS CloudFormation" },
                ],
            },
            {
                title: "Kubernetes + Docker + AWS Fargate",
                description: "A powerful serverless solution for container orchestration. Kubernetes manages containers, Docker packages applications, and AWS Fargate automates server management, allowing you to focus on code without worrying about infrastructure.",
                icons: [
                    { icon: "kubernetes.svg", altText: "Kubernetes container orchestration" },
                    { icon: "docker.svg", altText: "Docker container platform" },
                    { icon: "aws-fsc.png", altText: "AWS Fargate" },
                ],
            },
            {
                title: "GitLab + Docker + Azure Kubernetes Service (AKS)",
                description: "A seamless CI/CD pipeline that ensures continuous integration and deployment with GitLab, containerizes applications with Docker, and orchestrates containers using Azure Kubernetes Service for optimized cloud-native solutions.",
                icons: [
                    { icon: "gitlab.svg", altText: "GitLab" },
                    { icon: "docker.svg", altText: "Docker container platform" },
                    { icon: "kubernetes.svg", altText: "Azure Kubernetes Service" },
                ],
            },
            {
                title: "Jenkins + Docker + AWS ECS",
                description: "Streamline your deployment process with Jenkins to automate builds, Docker for containerization, and AWS ECS to manage container orchestration in a scalable, flexible environment.",
                icons: [
                    { icon: "jenkins.svg", altText: "Jenkins automation server" },
                    { icon: "docker.svg", altText: "Docker container platform" },
                    { icon: "aws-fsc.png", altText: "AWS ECS" },
                ],
            },
            {
                title: "AWS CodePipeline + Docker + Kubernetes",
                description: "Automate the CI/CD process with AWS CodePipeline, containerize your applications with Docker, and orchestrate them using Kubernetes for improved scalability and efficient deployments across cloud environments.",
                icons: [
                    { icon: "aws-fsc.png", altText: "AWS CodePipeline" },
                    { icon: "docker.svg", altText: "Docker container platform" },
                    { icon: "kubernetes.svg", altText: "Kubernetes container orchestration" },
                ],
            },
            {
                title: "Helm + Kubernetes + GKE",
                description: "For highly efficient Kubernetes management, Helm simplifies package management, Kubernetes orchestrates containers, and GKE offers managed Kubernetes for ease of deployment and scaling in Google Cloud.",
                icons: [
                    { icon: "helm.svg", altText: "Helm package manager" },
                    { icon: "kubernetes.svg", altText: "Kubernetes container orchestration" },
                    { icon: "google-gke.svg", altText: "Google Kubernetes Engine" },
                ],
            },
        ]
    },

    whyChooseBitsclanContet: [
        {
            id: "Tab1",
            label: "Vetted Senior DevOps Talent",
            content: "Only the top 1% of applicants pass our rigorous assessments in CI/CD, cloud management, and infrastructure as code. Our engineers have proven expertise in building and maintaining enterprise-grade DevOps environments.",
            btnText: "Connect with the clan",
            btnLink: "#",
        },
        {
            id: "Tab2",
            label: "Timezone-Aligned Collaboration",
            content: "Our teams work within your time zone, joining standups, sprint planning, and incident reviews in real-time. This ensures quick feedback, faster iteration, and seamless collaboration with no communication barriers.",
            btnText: "Connect with the clan",
            btnLink: "#",
        },
        {
            id: "Tab3",
            label: "Proficient in Communication",
            content: "Every engineer is fluent in English and adept at explaining complex infrastructure and automation concepts to both technical and business stakeholders, bridging the gap between development, operations, and leadership.",
            btnText: "Connect with the clan",
            btnLink: "#",
        },
        {
            id: "Tab4",
            label: "Full-Stack DevOps Capabilities",
            content: "From CI/CD pipelines and container orchestration to IaC and monitoring, our engineers manage the entire DevOps lifecycle, ensuring environments are secure, scalable, and optimized for continuous delivery.",
            btnText: "Connect with the clan",
            btnLink: "#",
        },
        {
            id: "Tab5",
            label: "Scalable Teams",
            content: "New engineers can onboard within days when expanding an existing team or launching a new DevOps initiative, with flexible engagement models that scale seamlessly as your project evolves.",
            btnText: "Connect with the clan",
            btnLink: "#",
        },
        {
            id: "Tab6",
            label: "Standard MSAs & SOWs",
            content: "We streamline onboarding with globally recognized contracts and compliance frameworks. Our MSAs and SOWs ensure enterprise transparency and alignment from day one.",
            btnText: "Connect with the clan",
            btnLink: "#",
        },
        {
            id: "Tab7",
            label: "NDA & IP Protection",
            content: "Security is core to every engagement. Strict NDAs, role-based access, and data governance protocols safeguard your architecture, automation scripts, and proprietary workflows.",
            btnText: "Connect with the clan",
            btnLink: "#",
        },
        {
            id: "Tab8",
            label: "Enterprise-Grade Security",
            content: "All DevOps operations comply with global standards like ISO 27001, SOC 2, and GDPR. We enforce secure code practices, encrypted communication, and continuous compliance monitoring.",
            btnText: "Connect with the clan",
            btnLink: "#",
        },
        {
            id: "Tab9",
            label: "Managed Delivery",
            content: "Every project is led by experienced delivery managers who monitor progress, resolve roadblocks, and ensure performance SLAs are met. Every deliverable is tracked and optimized for speed, stability, and measurable success.",
            btnText: "Connect with the clan",
            btnLink: "#",
        },
    ],

    engagementModels: {
        shortHeading: "Engagement Models",
        heading: "Customized DevOps Solutions for Business Growth",
        subheading: "Need DevOps expertise? Integrate us wherever you need us most. We customize every engagement to align with your workflow, infrastructure, and delivery goals whether scaling your operations team, automating deployments, or optimizing cloud infrastructure.",
        models: [
            {
                icon: "/images/engagement-model-gifs/hourly-icon.svg",
                index: 1,
                iconWidth: 40,
                title: "Flexible DevOps Expertise On-Demand",
                description: "Need additional DevOps engineers for specific projects or ongoing support? Quickly scale your operations with pre-vetted DevOps experts skilled in CI/CD automation, container orchestration, and cloud infrastructure all without the delays or overhead of traditional hiring processes."
            },
            {
                icon: "/images/engagement-model-gifs/price-icon.svg",
                index: 2,
                iconWidth: 35,
                title: "Dedicated Teams",
                description: "Need a full DevOps team to manage complex cloud or automation projects? We assemble dedicated teams focused exclusively on your business objectives managing everything from infrastructure provisioning, pipeline setup, to monitoring and system optimization."
            },
        ],
        cta: {
            text: "Talent on Your Terms",
            button: "Accelerate with DevOps",
            link: "/contact-us",
        },
    },

    // HirePageSteps Content
    hireSteps: {
        btnText: "Let's Find Your Perfect DevOps Engineer",
        heading: "How to Engage DevOps Engineers in 3 Simple Steps",
        steps: [
            {
                title: "Connect with Our DevOps Specialists",
                description: "Start by speaking with our DevOps consultants to discuss your project goals, infrastructure challenges, and technical requirements. We'll assess your current setup and identify the right expertise to accelerate your DevOps transformation and improve efficiency by up to 30%.",
                icon: "/images/hire-page-setps-icons/icon-1.svg",
            },
            {
                title: "Get Matched with Pre-Vetted DevOps Talent",
                description: "Within 24–48 hours, we'll connect you with top-tier DevOps engineers who are handpicked based on your project's scope and technology stack. Each engineer is pre-vetted for expertise in CI/CD automation, cloud infrastructure, containerization, and monitoring to ensure the best fit for your business needs.",
                icon: "/images/hire-page-setps-icons/icon-2.svg",
            },
            {
                title: "The Right Fit, Guaranteed",
                description: "Test our engineers with a risk-free trial to ensure they align with your workflow and goals. If the match isn't ideal, we'll provide a replacement within 48 hours—at no extra cost—ensuring your project stays on track without delays.",
                icon: "/images/hire-page-setps-icons/icon-3.svg",
            },
        ],
    },

    // CoverTheStack Content
    coverTheStack: {
        whereStart: "CI/CD & Automation",
        mainHeading: "Comprehensive Expertise Across the DevOps Stack",
        subHeading: "Our DevOps engineers leverage a modern tech stack designed for performance, scalability, and real-world impact. With hands-on experience across 100+ tools and platforms, we deliver end-to-end DevOps solutions from infrastructure automation and CI/CD pipelines to monitoring, security, and cloud optimization.",
        tabs: [
            "CI/CD & Automation",
            "Cloud Platforms",
            "Containerization",
        ],
        tabItems: [
            { tab: "CI/CD & Automation", icon: "/images/tech-stack-icons/jenkins.svg", name: "Jenkins" },
            { tab: "CI/CD & Automation", name: "GitLab CI", icon: "/images/tech-stack-icons/gitlab.svg" },
            { tab: "CI/CD & Automation", name: "GitHub Actions", icon: "/images/tech-stack-icons/github-actions.svg" },
            { tab: "Cloud Platforms", icon: "/images/tech-stack-icons/aws.svg", name: "AWS" },
            { tab: "Cloud Platforms", icon: "/images/tech-stack-icons/azure.svg", name: "Azure" },
            { tab: "Cloud Platforms", name: "Google Cloud", icon: "/images/tech-stack-icons/gcp.svg" },
            { tab: "Containerization", icon: "/images/tech-stack-icons/docker.svg", name: "Docker" },
            { tab: "Containerization", icon: "/images/tech-stack-icons/kubernetes.svg", name: "Kubernetes" },
        ],
    },

    challengesData: [
        {
            title: "Shortage of Experienced DevOps Engineers",
            description: "The demand for skilled DevOps engineers continues to outstrip supply. Many candidates may be familiar with automation tools but lack the hands-on experience required to manage complex pipelines, scale infrastructure, and maintain critical production systems.",
        },
        {
            title: "Lengthy Hiring & Onboarding Process",
            description: "Traditional hiring processes for DevOps talent are often slow, delaying your automation initiatives and extending deployment timelines. Evaluating candidates' expertise across a wide range of tools and environments can significantly slow down the process.",
        },
        {
            title: "Toolchain Complexity & Fragmented Ecosystems",
            description: "DevOps today involves managing a diverse set of tools from CI/CD to IaC, monitoring, and security. Without the right expertise, integrating these tools into a unified, efficient workflow can become time-consuming and error prone.",
        },
        {
            title: "Infrastructure Scalability & Reliability Issues",
            description: "Scaling infrastructure efficiently remains a significant challenge for organizations. Poorly optimized environments lead to downtime, inconsistent performance, and higher costs especially during traffic spikes or critical releases.",
        },
        {
            title: "Lack of Continuous Monitoring & Automation",
            description: "Without continuous monitoring and automation, DevOps systems can break under production load. Missing alerts, manual interventions, and limited visibility can cause delays in identifying and resolving issues, affecting system stability.",
        },
        {
            title: "Security & Compliance Challenges",
            description: "Managing secrets, enforcing access controls, and ensuring compliance across multi-cloud environments are ongoing challenges. Without integrated DevSecOps practices, vulnerabilities can remain undetected, compromising the system's overall integrity.",
        },
        {
            title: "Communication Gaps Between Development & Operations",
            description: "When Dev and Ops teams work in silos, it often leads to misaligned priorities, miscommunications, and delayed releases. Without clear collaboration and shared accountability, the core purpose of DevOps—speed, reliability, and efficiency—gets compromised.",
        },
    ],

    // HireExpertFacts Content
    expertFacts: {
        btnText: "book an appointment",
        heading: "Quick Facts About ",
        greenHeading: "Our DevOps Team",
        facts: [
            { text: "<strong>Experienced DevOps Engineers:</strong> Our team includes highly skilled engineers with expertise in CI/CD automation, cloud infrastructure, and container orchestration." },
            { text: "<strong>Diverse Project Experience:</strong> We've successfully worked on a wide range of DevOps projects, building scalable infrastructure and automation solutions across multiple industries." },
            { text: "<strong>Fast & Efficient Implementation:</strong> Our engineers use industry-best practices to create robust DevOps pipelines quickly while ensuring they are reliable, secure, and scalable." },
            { text: "<strong>Proven Record in Infrastructure Automation:</strong> Our team has deep understanding of infrastructure as code, containerization, and cloud platforms to deliver enterprise-grade solutions." },
            { text: "<strong>Multi-Cloud Expertise:</strong> Whether it's AWS, Azure, or GCP, we specialize in creating DevOps solutions that perform optimally across all major cloud platforms." },
            { text: "<strong>Continuous Support & Optimization:</strong> Our DevOps engineers provide full support throughout the implementation process and beyond, helping with monitoring, optimization, and ongoing improvements." },
        ],
        backgroundImage: `url(/images/hire-page-images/hire-devops.avif)`,
    },

    // HirePageAppIdea Content
    appIdeaSection: {
        heading: "Facing deployment bottlenecks or infrastructure chaos?",
        content: "Let our DevOps engineers streamline your operations with automation, scalability, and reliability built right in. Hire DevOps Engineer Now",
    },

    // HirePageEngagementModels Component Props
    hirePageEngagementModels: {
        btnText: "Get Started Now",
        headingContent: [
            { text: "Our Flexible" },
            { text: "Engagement Models" },
        ],
        discription: "Choose the engagement model that fits your project needs! Whether you need full-time, part-time, or hourly DevOps engineers, we offer flexible options to ensure seamless collaboration & maximum efficiency throughout your project.",
        hiringDetails: [
            {
                text: "Hourly Hiring",
                hours: "48",
                timeUnit: "hours",
                icon: "time.svg",
                bgColor: "#FDFDFF",
                durationLabel: "Duration",
                duration: "8 Hrs/Day",
                minimumDaysLabel: "Minimum Days",
                minimumDays: "30 Days",
                billingLabel: "Billing",
                billing: "Monthly",
                startWorkPhrase: "Start work in "
            },
            {
                text: "Full Time Hiring",
                hours: "72",
                timeUnit: "hours",
                icon: "full-time.svg",
                bgColor: "#FFFEFA",
                durationLabel: "Duration",
                duration: "8 Hrs/Day",
                minimumDaysLabel: "Minimum Days",
                minimumDays: "30 Days",
                billingLabel: "Billing",
                billing: "Monthly",
                startWorkPhrase: "Get started within "
            },
            {
                text: "Part Time Hiring",
                hours: "48",
                timeUnit: "hours",
                icon: "part-time.svg",
                bgColor: "#FDFFFA",
                durationLabel: "Duration",
                duration: "8 Hrs/Day",
                minimumDaysLabel: "Minimum Days",
                minimumDays: "30 Days",
                billingLabel: "Billing",
                billing: "Monthly",
                startWorkPhrase: "Launch in "
            },
        ],
    },

    // SecondFaq Content
    faqSection: {
        mainHeading: "Frequently Asked Questions about DevOps",
        faqData: [
            {
                id: "collapseOne",
                question: "How quickly can DevOps engineers start working on my project?",
                answer:
                    "At Bitsclan IT Solutions, our DevOps engineers can typically begin within 2–4 business days of agreement. We handle all onboarding steps from access setup and tool configuration to environment alignment ensuring your project starts without any operational downtime.",
            },
            {
                id: "collapseTwo",
                question: "What kind of projects can your DevOps engineers manage?",
                answer:
                    "Our engineers handle a wide range of DevOps initiatives, including CI/CD pipeline setup, cloud infrastructure management, containerization (Docker/Kubernetes), infrastructure as code (Terraform, Ansible), and automated monitoring. Whether it’s a new deployment or optimizing your current system, we tailor our approach to your goals.",
            },
            {
                id: "collapseThree",
                question: "How do you ensure reliability and quality in DevOps delivery?",
                answer:
                    "Every engineer at Bitsclan IT Solutions goes through a multi-stage vetting process, testing their expertise in cloud management, system security, and continuous integration workflows. We emphasize automation, redundancy, and proactive monitoring to guarantee uptime and scalability.",
            },
            {
                id: "collapseFour",
                question: "Can your DevOps engineers work with our in-house development team?",
                answer:
                    "Absolutely. Our engineers integrate seamlessly with your team’s existing workflows, joining your Slack, Jira, and standup meetings. They adapt to your sprint structure and communication style, ensuring full alignment and transparency across development and operations.",
            },
            {
                id: "collapseFive",
                question: "What cloud platforms and tools do your DevOps engineers use?",
                answer:
                    "We work across AWS, Azure, and Google Cloud, using tools like Docker, Kubernetes, Jenkins, Terraform, Ansible, GitLab CI/CD, Prometheus, and Grafana. Each toolchain is customized to your project’s architecture and scalability needs.",
            },
            {
                id: "collapseSix",
                question: "How do you maintain system security and compliance?",
                answer:
                    "Security is built into every stage of our DevOps process. We apply DevSecOps best practices, including secret management, continuous vulnerability scans, and role-based access controls. Our workflows comply with ISO 27001, SOC 2, and GDPR standards to ensure complete data protection.",
            },
            {
                id: "collapseSeven",
                question: "Can I scale my DevOps team as the project evolves?",
                answer:
                    "Yes. You can scale your team up or down within days based on project phases, new infrastructure requirements, or release schedules. Our flexible engagement model gives you full control without long-term commitments or resource bottlenecks.",
            },
            {
                id: "collapseEight",
                question: "What if a DevOps engineer isn’t the right fit for our project?",
                answer:
                    "If an engineer doesn’t meet expectations, we’ll replace them immediately at no additional cost. Our goal is to maintain delivery continuity and performance excellence with zero disruption to your operations.",
            },
            {
                id: "collapseNine",
                question: "How do you handle offboarding and project transitions?",
                answer:
                    "Before offboarding, our team performs a structured knowledge transfer, including detailed documentation, access credentials, and deployment procedures. All infrastructure assets remain under your complete ownership, ensuring a secure and smooth transition.",
            },
            {
                id: "collapseTen",
                question: "Do you provide post-engagement or managed delivery support?",
                answer:
                    "Yes. We offer post-engagement maintenance and managed delivery models, where our engineers continuously monitor infrastructure performance, optimize cloud usage, and implement improvements to ensure long-term stability and efficiency.",
            },
        ]
    },
    comapnyCtaContent: {
        heading: "Optimizing Infrastructure for Business Efficiency",
        subHeading: "See how our expert DevOps engineers can streamline your operations and accelerate delivery.",
        buttonText: "SCHEDULE A CALL",
    }
};